<app-modal title="EMPLOYEES.NEW_EMPLOYEE"
           [loading]="loading"
           (submitClicked)="submit()"
           [closeText]="'CANCEL'"
           [submitText]="'SAVE'"
>
  <app-employee-form (formGroupOutput)="formGroup = $event" />
</app-modal>
